const DefaultPluginSettings: IPluginSettings = {
    name: 'Настройки интерфейса',
    mnemocode: 'create_default_plugin_settings',
    columns: [{
        order: 0,
        propertyName: 'idGlobal',
        propertyType: 'string',
        displayName: 'ID',
        visibility: false,
        width: 100
    }, {
        order: 1,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Наименование',
        visibility: true,
        width: 300
    }
    ]
}

export default DefaultPluginSettings